<script setup lang="tsx">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { useAlert } from '../composables/useAlert';
import { useAppState } from '../store/ocg-app-state';
import { supabase } from '../supabase';
import { getMessage } from '../utils/exception';
import SingleForm from './SingleForm.vue';

const appState = useAppState();
const router = useRouter();
const alert = useAlert();

const busy = ref(false);
const dialogValid = ref<boolean | null>(null);
const name = ref('');
const email = ref('');

const rules = {
  required: (value: string) => !!value || 'Field is required',
  email: (value: string) =>
    /.[^\n\r@\u2028\u2029]*@.+\..{2,}/.test(value)
    || 'Please enter an email address',
};

const redirectNotificationId = ref('');

async function invite(event: Event) {
  event.preventDefault();
  busy.value = true;
  try {
    const redirectUrl = new URL(
      router.resolve({ name: 'superadmin' }).href,
      window.location.origin,
    ).toString();

    const { error } = await supabase.rpc('create_superadmin', {
      email: email.value,
      name: name.value,
      redirect_to: redirectUrl,
    });
    if (error) throw error;
    redirectNotificationId.value = alert.success(
      'Invitation sent - redirecting to login',
    );
    router.push('/login');
  }
  catch (error) {
    console.error(error);
    alert.error(getMessage(error));
  }
}
</script>

<template>
  <SingleForm>
    <h2>Good {{ appState.timeOfDay }}</h2>

    <h4>Set up your server</h4>
    <div class="mb-2" style="text-align: center">
      Invite and define the superadmin by email:
    </div>

    <v-form
      v-model="dialogValid"
      class="d-flex flex-column flex-wrap gy-4"
      validate-on="invalid-input"
      @submit.prevent="invite"
    >
      <v-row>
        <v-col cols="12" md="6" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.required]"
            label="Full Name"
          />
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <v-text-field
            v-model="email"
            label="Email"
            type="email"
            :rules="[rules.email]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn
            color="primary"
            type="submit"
            :disabled="dialogValid === false || busy"
          >
            Invite
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </SingleForm>
</template>
